// ─── Dashboard Background Config ─────────────────────────────────────────────
//
// To change a background:
//   1. Drop the new image into  public/theme/img/
//   2. Update the `image` value for the relevant key below.
//
// Available images:  bg.jpg  bg2.jpg  bg3.jpg  bg4.jpg
//                    bg5.jpg bg6.jpg  bg7.jpg  bg11.jpg
//
// `overlay` is a CSS gradient drawn on top of the image to ensure text stays
// readable. Solid dark tint:  'rgba(R, G, B, opacity)'
// Two-colour gradient:        'rgba(R,G,B,a), rgba(R,G,B,a)'
// Angled gradient:            '135deg, rgba(...) 0%, rgba(...) 100%'
// ─────────────────────────────────────────────────────────────────────────────

export const backgrounds = {
  rental:         { image: '/theme/img/bg2.jpg',  overlay: 'rgba(122, 126, 89, 0.54)'                                           },
  rentalMaster:   { image: '/theme/img/bg2.jpg',  overlay: 'rgba(122, 126, 89, 0.54)'                                           },
  rentalOverview: { image: '/theme/img/bg4.jpg',  overlay: '135deg, rgba(102, 126, 234, 0.7) 0%, rgba(118, 75, 162, 0.7) 100%' },
  sale:           { image: '/theme/img/bg3.jpg',  overlay: 'rgba(20, 35, 80, 0.45)'                                             },
  mto:            { image: '/theme/img/bg3.jpg',  overlay: 'rgba(20, 35, 80, 0.45)'                                             },
  online:         { image: '/theme/img/bg3.jpg',  overlay: 'rgba(20, 35, 80, 0.45)'                                             },
  event:          { image: '/theme/img/bg4.jpg',  overlay: 'rgba(90, 40, 70, 0.45), rgba(40, 25, 80, 0.5)'                     },
  salesYearly:    { image: '/theme/img/bg2.jpg',  overlay: 'rgba(122, 126, 89, 0.54)'                                           },
}

// Local background overrides, saved by the BG Master screen as compressed data
// URLs in localStorage. EACH module (category) has its own background:
//   bgoverride:mod:rental / :sale / :mto / :online / :event
// A module's own image wins; the single app-wide image (`bgoverride:app`, from
// the older one-image mode) is the fallback until a module gets its own; the
// bundled default image is last. Everything persists on the device.
const MODULE_OF_KEY = {
  rental: 'rental',
  rentalMaster: 'rental',
  rentalOverview: 'rental',
  salesYearly: 'rental',
  sale: 'sale',
  mto: 'mto',
  online: 'online',
  event: 'event',
}

export function moduleOverride(key) {
  try {
    if (typeof localStorage !== 'undefined') {
      const mod = MODULE_OF_KEY[key] || 'rental'
      return (
        localStorage.getItem('bgoverride:mod:' + mod) ||
        localStorage.getItem('bgoverride:app') ||
        null
      )
    }
  } catch (_) {
    /* localStorage unavailable */
  }
  return null
}

export function resolveImage(path) {
  try {
    if (typeof localStorage !== 'undefined') {
      const pathOverride = localStorage.getItem('bgoverride:' + path)
      if (pathOverride) return pathOverride
    }
  } catch (_) {
    /* localStorage unavailable — fall back to the default path */
  }
  return path
}

/**
 * Returns a Vue :style object for the .background-image div.
 * @param {keyof backgrounds} key
 */
export function makeBgStyle(key) {
  const bg = backgrounds[key] || backgrounds.rental
  const overlay = bg.overlay.includes('deg') || bg.overlay.includes('%')
    ? `linear-gradient(${bg.overlay})`   // already a gradient spec
    : bg.overlay.includes(',')
      ? `linear-gradient(${bg.overlay})` // two-colour stop
      : `linear-gradient(${bg.overlay}, ${bg.overlay})` // solid tint
  const image = moduleOverride(key) || resolveImage(bg.image)
  return {
    backgroundImage: `${overlay}, url('${image}')`,
  }
}
